export const GTM_ID = process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID

export const gtmSendEvent = (payload: object) => {
  window.dataLayer = window.dataLayer || []

  window.dataLayer.push(payload)
}
